/* eslint-disable max-lines */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './certificationsOverviewDashboard.scss';
import ButtonComponent from '../../Components/Button/button.js';
import {
  CERTIFICATION_OVERVIEW,
  ADD_EDIT_RESPONSE_MESSAGES,
  DOWNLOAD,
} from '../../Constants/strings.js';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box, Grid, Paper, Typography } from '@mui/material';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import {
  getCertificationOverviewPdf,
  getCertificationOverviewExcel,
} from '../../Api/request/reports.js';
import SimpleSnackbar from '../../Components/Snackbar/snackbar.js';
import {
  getCertificationsTabsData,
  fetchTargetPieData,
  getTargetsData,
} from './certificationOverviewApiCall.js';
import CertificationTabs from './tabsComponent.js';
import CertificationTable from './quaterTargetAchieved.js';
import CertificationPieChart from './pieChartComponent.js';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

const Certifications = () => {
  const containerRef = useRef(null);
  const [chartSize, setChartSize] = useState({ width: 400, height: 400 });
  const [activeTab] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEll, setAnchorEll] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [ispdfHovered, setIspdfHovered] = useState(false);
  const [isexcelHovered, setIsexcelHovered] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const [targetData, setTargetData] = useState([
    {
      quarter: 'Q1(Jan - Mar)',
      currentQuarterTarget: 0,
      currentQuarterAchieved: 0,
      currentQuarterOverachieved: 0,
      currentQuarterPending: 0,
      uniqueAchievedCount: 0,
    },
    {
      quarter: 'Q2(Apr - Jun)',
      currentQuarterTarget: 0,
      currentQuarterAchieved: 0,
      currentQuarterOverachieved: 0,
      currentQuarterPending: 0,
      uniqueAchievedCount: 0,
    },
    {
      quarter: 'Q3(Jul - Sep)',
      currentQuarterTarget: 0,
      currentQuarterAchieved: 0,
      currentQuarterOverachieved: 0,
      currentQuarterPending: 0,
      uniqueAchievedCount: 0,
    },
    {
      quarter: 'Q4(Oct - Dec)',
      currentQuarterTarget: 0,
      currentQuarterAchieved: 0,
      currentQuarterOverachieved: 0,
      currentQuarterPending: 0,
      uniqueAchievedCount: 0,
    },
  ]);
  const [graphData, setGraphData] = useState([]);
  const [total, setTotal] = useState(0);
  const [cards, setCards] = useState([]);
  const [yearlyUniqueUserCount, setYearlyUniqueUserCount] = useState([]);
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    // eslint-disable-next-line id-length
    return Array.from({ length: 5 }, (_, index) => currentYear - index);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [stateSelectedYear, setStateSelectedYear] = useState(
    location.state?.userSelectedYear || null,
  );

  const generateInitialTargetData = () => {
    const quarters = [
      'Q1(Jan - Mar)',
      'Q2(Apr - Jun)',
      'Q3(Jul - Sep)',
      'Q4(Oct - Dec)',
    ];
    return quarters.map((quarter) => ({
      quarter,
      currentQuarterTarget: 0,
      currentQuarterAchieved: 0,
      currentQuarterOverachieved: 0,
      currentQuarterPending: 0,
      uniqueAchievedCount: 0,
    }));
  };

  const calculateTotals = () => {
    let totalTarget = 0;
    let totalAchieved = 0;
    let totalOverachieved = 0;
    let totalPending = 0;

    targetData?.forEach((item) => {
      totalTarget += item.currentQuarterTarget;
      totalAchieved += item.currentQuarterAchieved;
      totalOverachieved += item.currentQuarterOverachieved;
      totalPending += item.currentQuarterPending;
    });
    return {
      totalTarget,
      totalAchieved,
      totalPending,
      totalOverachieved,
      yearlyUniqueUserCount,
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCertificationsTabsData();
        setCards(data);
      } catch (error) {
        snackbarOpen();
        console.error('certification tabs error', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleButtonClick = (event) => {
    setAnchorEll(event.currentTarget);
  };

  const handleCloseMenuYear = () => {
    setAnchorEll(null);
  };

  const handleYearSelect = (year) => {
    if (selectedYear === year) {
      setSelectedYear(null);
      setTimeout(() => {
        setSelectedYear(year);
        setTargetData(generateInitialTargetData());
        setGraphData([]);
        setTotal(0);
        setYearlyUniqueUserCount(0);
      }, 0);
    } else {
      setSelectedYear(year);
      setTargetData(generateInitialTargetData());
      setGraphData([]);
      setTotal(0);
      handleCloseMenuYear();
      setYearlyUniqueUserCount(0);
    }
    setStateSelectedYear(null);
    handleCloseMenuYear();
  };

  useEffect(() => {
    const fetchData = async () => {
      const yearToUse = stateSelectedYear ?? selectedYear;
      if (yearToUse === null) return;

      try {
        const data = await getTargetsData(yearToUse);
        setTargetData(data.targetDetails);
        setYearlyUniqueUserCount(data.yearlyUniqueCount);
      } catch (error) {
        snackbarOpen();
        console.error('targets error', error);
      }
    };
    fetchData();
  }, [selectedYear, stateSelectedYear]);

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const { width, height } = containerRef.current.getBoundingClientRect();
        setChartSize({ width: width, height: height });
      }
    };
    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= 769); // Adjust the width as per your requirement
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const yearToUse = stateSelectedYear ?? selectedYear;
    if (yearToUse === null) return;

    const fetchData = async () => {
      try {
        const data = await fetchTargetPieData(yearToUse);
        setGraphData(data.mData);
        setTotal(data.totalValue);
      } catch (error) {
        snackbarOpen();
        console.error('pie chart error', error);
      }
    };
    fetchData();
  }, [selectedYear, stateSelectedYear]);

  const handleVerticalClick = (index, title) => {
    // eslint-disable-next-line max-len
    navigate(`/certifications/map?vertical=${encodeURIComponent(title)}`, {
      state: {
        fromPage: true,
        userSelectedYear: stateSelectedYear ?? selectedYear,
      },
    });
  };

  const handleAchievedClick = (index, quarter, year) => {
    const quarterMap = {
      'Q1(Jan - Mar)': 1,
      'Q2(Apr - Jun)': 2,
      'Q3(Jul - Sep)': 3,
      'Q4(Oct - Dec)': 4,
    };
    const quarterNumber = quarter === 'yearly' ? 'yearly' : quarterMap[quarter];
    // eslint-disable-next-line max-len
    navigate(`/certifications/map?quarter=${quarterNumber}&year=${year}`, {
      state: {
        fromPage: true,
        userSelectedYear: stateSelectedYear ?? selectedYear,
        showToast: true,
      },
    });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };

  const handleDownloadPdf = async () => {
    try {
      const yearToUse = stateSelectedYear ?? selectedYear;
      await getCertificationOverviewPdf(yearToUse);
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadExcel = async () => {
    try {
      const yearToUse = stateSelectedYear ?? selectedYear;
      await getCertificationOverviewExcel(yearToUse);
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };
  const colors = ['#6b5ce8', '#a29aff', '#c5c0ff', '#e8e6ff'];
  return (
    <div className="certification-master-outer-layer">
      <div className="certification-master">
        <div className="certification-master-title">
          {CERTIFICATION_OVERVIEW}
        </div>
        <div className="certification-search-and-buttons">
          <div className="certification-button">
            <div>
              <ButtonComponent
                label={stateSelectedYear ?? selectedYear}
                variant="text"
                onClick={handleButtonClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss="download-certification-btn"
              />
              <Menu
                anchorEl={anchorEll}
                open={Boolean(anchorEll)}
                onClose={handleCloseMenuYear}
              >
                {generateYearOptions().map((year) => (
                  <MenuItem
                    key={year}
                    onMouseEnter={() => setIspdfHovered(true)}
                    onMouseLeave={() => setIspdfHovered(false)}
                    onClick={() => handleYearSelect(year)}
                  >
                    {year}
                  </MenuItem>
                ))}
              </Menu>
            </div>
            <div className="certification-button-download">
              <ButtonComponent
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss="download-certification-btn"
              />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="downloadcertification-dropdown"
                  onMouseEnter={() => setIspdfHovered(true)}
                  onMouseLeave={() => setIspdfHovered(false)}
                >
                  <img
                    src={ispdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="downloadcertification-dropdown"
                  onMouseEnter={() => setIsexcelHovered(true)}
                  onMouseLeave={() => setIsexcelHovered(false)}
                >
                  <img
                    src={isexcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="Excel Icon"
                  />
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '400px',
            }}
          >
            <img
              src={PuzzleLoader}
              alt="Loading..."
              className="loader-gif"
              style={{ width: '100px', height: 'auto' }}
            />
          </div>
        ) : (
          <div className="data-grid-container">
            <div className="vertical-target-tabs">
              <CertificationTabs
                cards={cards}
                activeTab={activeTab}
                handleVerticalClick={handleVerticalClick}
                selectedYear={stateSelectedYear ?? selectedYear}
              />
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container columnSpacing="20px" rowSpacing="20px">
                <Grid item xs={12} md={8}>
                  <Paper elevation={3} style={{ height: '100%' }}>
                    <div className="total-result">
                      <div className="table-container" elevation={3}>
                        <Typography>
                          <div className="table-title-text">
                            Showing total results
                          </div>
                        </Typography>
                        <div className="table-container-2">
                          <CertificationTable
                            targetData={targetData}
                            handleAchievedClick={handleAchievedClick}
                            calculateTotals={calculateTotals}
                            selectedYear={stateSelectedYear ?? selectedYear}
                          />
                        </div>
                      </div>
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper
                    className="chart-container"
                    elevation={3}
                    style={{ height: '100%' }}
                  >
                    <Typography className="chart-title">
                      Certifications achieved
                    </Typography>
                    <div
                      ref={containerRef}
                      style={{
                        height: '300px',
                        width: '100%',
                        // backgroundColor: '#fff',
                        color: 'black',
                        borderRadius: '4px',
                      }}
                    >
                      <CertificationPieChart
                        chartSize={chartSize}
                        graphData={graphData}
                        total={total}
                        selectedYear={stateSelectedYear ?? selectedYear}
                      />
                    </div>
                    {!isMobile && (
                      <div>
                        {graphData.map((item, index) => (
                          <div className="chart-legend" key={item.label}>
                            <span
                              className="chart-legend-properties"
                              style={{
                                backgroundColor: colors[index % colors.length],
                              }}
                            ></span>
                            <span>
                              {item.label}- {item.value}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </div>
        )}
        <SimpleSnackbar
          open={openSnackbar}
          message={snackbarMessage}
          severity={severity}
          alertCss={`certification-snackbar ${severity}`}
        />
      </div>
    </div>
  );
};
export default Certifications;
